import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Page } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';

import PermissionModal from '../../components/widgets/PermissionModal';

import { Icon } from '../../components/widgets';
import { Link } from 'react-router-dom';

import {
  fetchUsers, confirmationRequest, setPageTitle
} from 'signoxe/actions';

import {
  getUsers, isFetching
} from 'signoxe/selectors';

import { SUBUSER_RESOURCE } from '../../api/resources';

import './styles.scss';

import _ from 'lodash';

class ClientUserListPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      visible: false,
      reset: false,
      editMial: false
    }
    this.handleCancel = this.handleCancel.bind(this)
  }

  componentDidMount() {
    this.props.fetchUsers()
    this.props.setPageTitle('Client Users...')
  }

  handleCancel() {
    this.setState({ visible: false, user: null, reset: false, editMial: false })
  }

  editUserPerms(user) {
    this.setState({ visible: true, user })
  }

  resetPassword(user) {
    this.setState({ visible: true, user, reset: true })
  }

    
  resetEmail(user) {
    this.setState({ visible: true, user, editMial: true })
  }

  handleUserDelete = (user) =>
    this.props.confirmationRequest(
      'Deleting User',
      `Deleting the user "${user.username}".`,
      'DELETE',
      SUBUSER_RESOURCE,
      user.id,
    )

  render() {
    const { users } = this.props;
    const { visible, user, reset, editMial } = this.state;
    const empty = _.isEmpty(users);
    return (
      <Page className="user-manage-page">
        <h3></h3>
        <Link className='button' to='/client-users-create'>
          Create User
        </Link>
        <table className="user-manage-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              !empty && _.map(users, (user, key) => (
                <tr key={key}>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td><Button onClick={() => this.resetEmail(user.id)}>Edit Email</Button></td>
                  <td><Button onClick={() => this.editUserPerms(user.id)}>Edit Permissions</Button></td>
                  <td><Button onClick={() => this.resetPassword(user.id)}>Reset Password</Button></td>
                  <td>
                    <Icon
                      title="Delete"
                      name="trash-o"
                      size="1.5rem"
                      onClick={() => this.handleUserDelete(user)} />
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
        <PermissionModal editMial={editMial} reset={reset} onCancel={this.handleCancel} userID={user} users={users} visible={visible} />
      </Page>
    );
  }
}

export default connect((state, props) => {
  return {
    users: getUsers(state)
    // isFetching: isFetching(state)
  };
},
  {
    fetchUsers, confirmationRequest, setPageTitle
  },
)(ClientUserListPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ClientUserListPage/index.js